import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { BlogService } from 'src/app/api/blog.service';
import { BlogPost, BlogPostType } from 'src/app/models/blog';

interface Timer {
  days: number;
  hours: number;
  minutes: number;
}

enum TradersChartType {
  Core = 'Core',
  Pro = 'Pro',
  Rewards = 'Rewards'
}

@Component({
  selector: 'app-trading-competition',
  templateUrl: './trading-competition.component.html',
  styleUrls: ['./trading-competition.component.scss']
})
export class TradingCompetitionComponent implements OnInit, OnDestroy {
  REGISTER_LINK_EN = 'https://forms.gle/SeADAgKgZrR9ikrQ9';
  REGISTER_LINK_AR = 'https://forms.gle/Dnd9yf7t5RErjpdBA';
  CONTEST_END_DATE = new Date('2022/03/31 23:59:59 GMT+0400');

  TradersChartType = TradersChartType;

  timer: Timer;
  timerSubscription: Subscription;
  tradersChartType: TradersChartType;

  data: BlogPost;
  loading = false;
  error: string = null;

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private blogService: BlogService
  ) { }

  ngOnInit(): void {
   this.startTimer();
   this.setTradersChartType(TradersChartType.Core);
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  startTimer () {
    this.timerSubscription = timer(0, 10000).subscribe(_ => {
      this.timer = this.getTime();
    });
  }

  get isAr() {
    return this.locale === 'ar';
  }

  getTime (): Timer {
    const now = new Date();
    const diff = this.CONTEST_END_DATE.getTime() - now.getTime();

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    return {
      days: minutes >= 0 ? days : 0,
      hours: minutes >= 0 ? hours : 0,
      minutes: minutes >= 0 ? minutes : 0,
    }
  }

  getBlog(type: TradersChartType) {
    this.loading = true;
    this.error = null;

    this.blogService.getOne({
      type: BlogPostType.Page,
      slug: this.getBlogPageSlug(type),
    }).subscribe(response => {
      this.loading = false;
      this.data = response;
    }, err => {
      this.loading = false;
      this.error = 'Error loading top traders';
    })
  }

  setTradersChartType(type: TradersChartType) {
    this.tradersChartType = type;
    this.getBlog(type);
  }

  getBlogPageSlug(type: TradersChartType) {
    switch (type) {
      case TradersChartType.Core:
        return 'Jan22-competition-top-core-traders';
      case TradersChartType.Pro:
        return 'Jan22-competition-top-pro-traders';
      case TradersChartType.Rewards:
        return 'Jan22-competition-rewards';
      default:
        return '';
    }
  }

}
